/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */

import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  setApiSuccess,
  setApiError,
  setComponentError,
  setComponentLoading,
  setComponentSuccess
} from './actions';

import errors from '../config/errors';
import { API_REQUEST } from './action-types';

const makeRequest = options => {
  const token = localStorage.getItem('token') || '';
  const request = axios.create({
    baseURL: process.env.LAB100_APP_ENDPOINT_API,
    timeout: 120000,
    responseType: 'json',
    withCredentials: false,
    headers: {
      'Access-Control-Allow-Origin':'*',
      'X-Lab100-App-UUID': process.env.LAB100_APP_UUID,
      'X-Lab100-App-Secret': process.env.LAB100_APP_SECRET,
      'Ocp-Apim-Subscription-Key': process.env.LAB100_APP_SUBSCRIPTION_KEY,
      ...(token && { Authorization: `Bearer ${token}` })
    }
  });

  if(Object.keys(options).length <= 0){
    return {}
  }

  return request(options)
    .then(result => ({ result }))
    .catch(error => ({ error }));
};

function* onRequest(data) {
  const payload = data.payload ? data.payload : {};
  const meta = data.meta ? data.meta : {};

  const {
    onBeforeRequest,
    onSuccess,
    onError,
    Component,
    ignoreErrorStatus
  } = meta;

  if (meta.assert && meta.assert.hasError) {
    if (Component) yield put(setComponentError(meta.assert.error, meta));
    if (onError) onError(meta.assert.error, meta);
    return;
  }

  if (onBeforeRequest) onBeforeRequest();
  if (Component) yield put(setComponentLoading(meta));

  const { result, error } = yield call(makeRequest, payload);

  meta.originalPayload = payload;
  meta.requestAction = data;

  if (error) {
    console.log(error.message);
    meta.status = error.response ? error.response.status : null;
    const message =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : errors.basic;

    if (ignoreErrorStatus !== meta.status)
      yield put(setApiError(message, meta));
    if (Component) {
      yield put(setComponentError(message, meta));
    }
    if (onError) onError(message, meta);
  } else if (result) {
    meta.status = result.status;
    if (onSuccess) onSuccess(result, meta);
    yield put(setApiSuccess(result, meta));
    if (Component) yield put(setComponentSuccess(result, meta));
  }
}

function* handleApi() {
  yield takeEvery(API_REQUEST, onRequest);
}

export default handleApi;
